module.exports = __webpack_public_path__ + "media/concept_pipeline-a44b091d61c858784f02221a7d83a984.svg";